import React, { useCallback, useEffect, useMemo, useState } from "react";
import TeamBlock from "./formComponents/OpposingTeamBlock";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import LocationSelect from "./formComponents/LocationSelect";
import PitchSelect from "./formComponents/PitchSelect";
import CancelButton from "./formComponents/CancelButton";
import ConfirmButton from "./formComponents/ConfirmButton";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import _ from "lodash";
import { putItem } from "../../../utils/api";
import { normaliseForm } from "../helpers/normaliseForm";
import { getInitForm } from "../helpers/getInitForm";
import "../styles/MatchListItem.css";
import { useDispatch } from "react-redux";
import { matchDelete, matchSubmitSuccess } from "../redux/actions";
import Loader from "sulu-admin-bundle/components/Loader";

import StatusSelect from "./formComponents/StatusSelect";
import MatchListGroup from "./MatchListGroup";
import MatchListWithoutMatchdays from "./MatchListWithoutMatchdays";

export default function MatchListItem({
    match,
    withForm,
    matchDayId,
    matchDay,
}) {
    const dispatch = useDispatch();
    const initialForm = useMemo(() => getInitForm(match), [match]);
    const [form, setForm] = useState(initialForm);
    const [loading, setLoading] = useState(false);
    const [pitchOptions, setPitchOptions] = useState(
        match.pitchID && match.pitch
            ? [{ id: match.pitchID, name: match.pitch }]
            : []
    );

    useEffect(() => {
        setForm(initialForm);
    }, [initialForm]);

    const isDirty = !_.isEqual(form, initialForm);

    const handleFormChange = useCallback((newValues) => {
        setForm((prevState) => ({
            ...prevState,
            ...newValues,
        }));
    }, []);

    const removePitchOptions = useCallback(() => {
        setPitchOptions([]);
    }, []);

    const handleFormChangeLocation = async (newValue) => {
        setPitchOptions([]);
        if (newValue === null) {
            setForm((prev) => ({
                ...prev,
                location: null,
                locationID: null,
                pitchID: null,
                pitch: null,
            }));
            return;
        }

        setForm((prev) => ({
            ...prev,
            location: newValue,
            locationID: newValue.id,
            pitchID: null,
            pitch: null,
        }));
    };

    const handleSubmit = useCallback(async () => {
        const submitMatchUrl = `/admin/api/dhbmatchdays/${matchDayId}`;
        setLoading(true);

        try {
            const responseMatches = await putItem(
                submitMatchUrl,
                normaliseForm(form)
            );

            dispatch(matchSubmitSuccess(responseMatches));
            setLoading(false);
        } catch (error) {
            console.log(error);
            console.log("league Submit Error");
            setLoading(false);
        }
    }, [form]);

    const handleCancel = useCallback(async () => {
        const deleteMatchUrl = `/admin/api/dhbmatchdays/${matchDayId}`;
        setLoading(true);
        try {
            const responseLeagues = await putItem(deleteMatchUrl, {
                dhbMatch: match?.id,
                removeMatchDay: true,
            });
            dispatch(matchDelete(matchDayId, match?.id));
            setLoading(false);
        } catch (error) {
            console.log("league Delete Error");
            setLoading(false);
        }
    }, []);

    return (
        <div className={`match-list-block ${!withForm && "without-matchdays"}`}>
            {!withForm && <MatchListWithoutMatchdays match={form} />}
            {withForm && (
                <>
                    <MatchListGroup form={form} />

                    <div className="match-list-block-item opposing-team-align-center">
                        <TeamBlock team={form?.homeTeam} home={true} />
                    </div>
                    <div className="match-list-block-item opposing-team-align-center">
                        <TeamBlock team={form?.awayTeam} home={false} />
                    </div>

                    <div className="match-list-block-item date-picker">
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                                value={form?.scheduleDate}
                                onChange={(value) => {
                                    handleFormChange({
                                        scheduleDate: value,
                                    });
                                }}
                            />
                        </LocalizationProvider>
                    </div>
                    <div className="match-list-block-item time-picker">
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <TimePicker
                                ampm={false}
                                value={form?.scheduleTime}
                                onChange={(value) => {
                                    handleFormChange({
                                        scheduleTime: value,
                                    });
                                }}
                            />
                        </LocalizationProvider>
                    </div>
                    <div className="match-list-block-item location-select">
                        <LocationSelect
                            slotProps={{ textField: { fullWidth: true } }}
                            match={match}
                            onChange={handleFormChangeLocation}
                            onChangeForm={handleFormChange}
                            removePitchOptions={removePitchOptions}
                        />
                    </div>
                    <div className="match-list-block-item pitch-select">
                        <PitchSelect
                            match={match}
                            pitchOptions={pitchOptions}
                            setPitchOptions={setPitchOptions}
                            onChangeForm={handleFormChange}
                            form={form}
                        />
                    </div>

                    <div className="match-list-block-item status-select">
                        <StatusSelect form={form} onChange={handleFormChange} />
                    </div>
                    <div className="match-list-block-item btn-wrap">
                        {loading ? (
                            <Loader size={20} />
                        ) : (
                            <>
                                <div className="match-list-block-item form-btn">
                                    <ConfirmButton
                                        disabled={!isDirty}
                                        onClick={handleSubmit}
                                    />
                                </div>
                                <div className="match-list-block-item form-btn">
                                    <CancelButton onClick={handleCancel} />
                                </div>
                            </>
                        )}
                    </div>
                </>
            )}
        </div>
    );
}
